import { createConfirmation } from "react-confirm";
import CreateScheduleModal from "./CreateScheduleModal";

export const showCreateScheduleModal = createConfirmation(CreateScheduleModal);
